<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6">
                <div class="service">
                    <h2>
                        ارشفة المواقع SEO
                    </h2>
                    <p>
                        ارشفة المواقع SEO هى خدمة ارشفة مواقع الانترنت و احد اساسيات السيو SEO والمعروف اختصاراً بـ (Search Engine Optimization) وهو عملية تحسين الموقع وتهيئته للحصول على ارشفة احترافية سليمة وترتيب جيد لزيادة عدد الزوار
                    </p>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/seo-img.png" alt="seo" />
            </div>
        </div>
    </div>
</section>